import cloneDeep from 'lodash/cloneDeep';
import get from 'lodash/get';
import has from 'lodash/has';
import isEmpty from 'lodash/isEmpty';
import remove from 'lodash/remove';
import set from 'lodash/set';
import type { ConditionType, QuestionType } from '../reducers';
import { TERRABLOB_METADATA_KEY } from '../reducers';
import { updateFollowUp } from './compat';
export const removeFollowup = (question: QuestionType, followUpIdx?: number, followUpQuestionId?: string) => {
  const nextQuestion = cloneDeep(question);
  const followUp = followUpIdx !== undefined && (nextQuestion.followUps || [])[followUpIdx];
  if (followUp) {
    // @ts-expect-error todo(ts-migration) TS2345 Argument of type '{ conditions: ConditionsType; questionId?: string; questionIds?: string[]; }' is not assignable to parameter of type 'FollowUpType'.
    const newFollowUp = updateFollowUp({
      ...followUp
    });
    if (newFollowUp.questionIds.length > 1) {
      newFollowUp.questionIds = newFollowUp.questionIds.filter(id => id !== followUpQuestionId);
      if (followUpIdx !== undefined) {
        nextQuestion.followUps[followUpIdx] = {
          ...newFollowUp
        };
      }
    } else {
      // single followup question
      remove(nextQuestion.followUps, (_, idx: number) => idx === followUpIdx);
    }
  }
  return nextQuestion;
};
export const addNewOrCondition = (question: QuestionType, condition: ConditionType, followUpIdx: number) => {
  const nextQuestion = cloneDeep(question);
  const andConditions = get(nextQuestion, `followUps.${followUpIdx}.conditions`) || [];
  andConditions.push([condition]);
  set(nextQuestion, `followUps.${followUpIdx}.conditions`, andConditions);
  return nextQuestion;
};
export const addNewAndCondition = (question: QuestionType, condition: ConditionType, followUpIdx: number, orIdx: number) => {
  const nextQuestion = cloneDeep(question);
  const andConditions = get(nextQuestion, `followUps.${followUpIdx}.conditions.${orIdx}`) || [];
  andConditions.push(condition);
  set(nextQuestion, `followUps.${followUpIdx}.conditions.${orIdx}`, andConditions);
  return nextQuestion;
};
export const updateCondition = (question: QuestionType, updatedCondition: ConditionType, followUpIdx: number, orIdx: number, andIdx: number) => {
  const nextQuestion = cloneDeep(question);
  if (has(nextQuestion, `followUps.${followUpIdx}.conditions.${orIdx}`)) {
    set(nextQuestion, `followUps.${followUpIdx}.conditions.${orIdx}.${andIdx}`, updatedCondition);
  } else {
    set(nextQuestion, `followUps.${followUpIdx}.conditions.${orIdx}`, [updatedCondition]);
  }
  return nextQuestion;
};
export const deleteCondition = (question: QuestionType, followUpIdx: number, orIdx: number, andIdx: number) => {
  const nextQuestion = cloneDeep(question);
  const orConditions = get(nextQuestion, `followUps.${followUpIdx}.conditions.${orIdx}`) || [];
  remove(orConditions, (_, idx: number) => idx === andIdx);
  if (isEmpty(orConditions)) {
    const andConditions = get(nextQuestion, `followUps.${followUpIdx}.conditions`) || [];
    remove(andConditions, (_, idx: number) => idx === orIdx);
    set(nextQuestion, `followUps.${followUpIdx}.conditions`, andConditions);
  } else {
    set(nextQuestion, `followUps.${followUpIdx}.conditions.${orIdx}`, orConditions);
  }
  return nextQuestion;
};
export const getTerrablobPath = (question: QuestionType) => question.answers[0]?.metadata?.[TERRABLOB_METADATA_KEY];
export function getWordCount(paragraph: string): number {
  if (!paragraph) {
    return 0;
  }
  return paragraph.trim().split(/\s+/).length;
}